// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("/images/new_spinner.svg", import.meta.url);
// Module
var code = `<div id="google-pay-container" ng-show="googlepay.isInitialized && googlepay.isSupported"></div> <div ng-show="!googlepay.isInitialized && googlepay.isSupported"> <img class="payment-spinner" src="${___HTML_LOADER_IMPORT_0___}" alt="Loading"/> </div> `;
// Exports
export default code;